import React, { useState } from "react";
import { ChakraProvider, useToast } from "@chakra-ui/react";
import folderLogo from "../../images/folderLogo.png";
import noFolderLogo from "../../images/sad.png";
import { useSelector } from "react-redux";
import axios from "axios";

function SelectFolderModal({ onClose, onSelect, currentPath }) {
  const formattedCurrentPath = currentPath
    ? currentPath.replace(/\/$/, "")
    : currentPath;

  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const token = sessionStorage.getItem("number");
  const [selectedPath, setSelectedPath] = useState(null);
  const [isRadioChecked, setIsRadioChecked] = useState(false);
  const toast = useToast();
  const [locationPath, setLocationPath] = useState("");
  const [displayPath, setDisplayPath] = useState(null);
  const [fullPath, setFullPath] = useState(null);
  const isSharedValue = useSelector((state) => state.getdata.isSharedValue);
  const sharedFolderList = useSelector(
    (state) => state.getdata.sharedFolderList
  );
  const rootFolderList = useSelector((state) => state.getdata.rootFolderList);

  const baseList = isSharedValue ? sharedFolderList : rootFolderList;
  const folders = Array.isArray(baseList[0])
    ? baseList[0]
    : baseList[0]?.[0] || [];

  const [folderStack, setFolderStack] = useState([folders]);
  const [currentFolders, setCurrentFolders] = useState(folders);

  const filenameRedux = useSelector((state) => state.getdata.fileName);
  const counter = useSelector((state) => state.getdata.folderCounter);
  const counter2 = useSelector((state) => state.getdata.counter);
  const [pathTrail, setPathTrail] = useState([]);

  const handleItemClick = async (path) => {
    const folderName = path.split("/").pop();

    try {
      const params = {
        folderPath: path,
        ...(isSharedValue && { shared: filenameRedux }),
      };

      const res = await axios.get(`${apiUrl}getFolder`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const subfolders = res.data.filter(
        (item) => item?.isFolder === true || item?.isFolder === "true"
      );

      setFolderStack((prev) => [...prev, subfolders]);
      setCurrentFolders(subfolders);
      setPathTrail((prev) => [...prev, folderName]);
      setSelectedPath(path);
      setIsRadioChecked(true);
    } catch (error) {
      console.error("Error fetching folder data:", error);
    }
  };

  const handleBack = () => {
    if (folderStack.length > 1) {
      const updatedStack = [...folderStack];
      updatedStack.pop();
      setFolderStack(updatedStack);
      setCurrentFolders(updatedStack[updatedStack.length - 1]);
      setPathTrail((prev) => prev.slice(0, -1));
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleConfirm = () => {
    if (selectedPath !== null) {
      onSelect(selectedPath);
      toast({
        title: "Folder Selected",
        description: `Selected Path: ${selectedPath || "Root Folder"}`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    }
    onClose();
  };

  return (
    <ChakraProvider>
      <div className="popup-container">
        <div className="move-to-popup">
          <div className="move-to-modal">
            <div className="move-to-header with-back">
              {folderStack.length > 1 && (
                <button className="back-button" onClick={handleBack}>
                  <i className="icon-arrow-left"></i> Back
                </button>
              )}
              <h3 className="move-to-title">Move To</h3>
              <p className="move-to-location">
                Location : <span>{pathTrail.join(" / ")}</span>
              </p>
            </div>

            <div className="move-to-body">
              <ul className="move-to-folder-list">
                {folderStack.length === 1 && formattedCurrentPath && (
                  <li
                    className={`folder-option ${
                      selectedPath === formattedCurrentPath ? "selected" : ""
                    }`}
                    onClick={() => {
                      setSelectedPath(formattedCurrentPath);
                      setIsRadioChecked(true);
                    }}
                  >
                    <div
                      className="custom-radio"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedPath(formattedCurrentPath);
                        setIsRadioChecked(true);
                      }}
                    >
                      {selectedPath === formattedCurrentPath && (
                        <div className="inner-circle" />
                      )}
                    </div>
                    <span>
                      Current Path (
                      {formattedCurrentPath
                        ? formattedCurrentPath.split("/").pop()
                        : ""}
                      )
                    </span>
                  </li>
                )}

                {folderStack.length === 1 && (
                  <li
                    className={`folder-option ${
                      selectedPath === "" ? "selected" : ""
                    }`}
                    onClick={() => {
                      setSelectedPath("");
                      setIsRadioChecked(true);
                    }}
                  >
                    <div
                      className="custom-radio"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedPath("");
                        setIsRadioChecked(true);
                      }}
                    >
                      {selectedPath === "" && <div className="inner-circle" />}
                    </div>
                    <span>
                      {isSharedValue ? "SHARED ROOT FOLDER" : "Root Folder"}
                    </span>
                  </li>
                )}

                {currentFolders.length > 0 ? (
                  currentFolders.map((folder, index) => (
                    <li
                      key={index}
                      className={`folder-option ${
                        selectedPath === folder.fileName ? "selected" : ""
                      }`}
                      onClick={() => handleItemClick(folder.fileName)}
                    >
                      <div
                        className="custom-radio"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedPath(folder.fileName);
                          setIsRadioChecked(true);
                        }}
                      >
                        {selectedPath === folder.fileName && (
                          <div className="inner-circle" />
                        )}
                      </div>
                      <img src={folderLogo} alt="Folder Icon" />
                      <span>{(folder.fileName || "").split("/").pop()}</span>
                    </li>
                  ))
                ) : (
                  <div className="empty-state">
                    <img
                      src={noFolderLogo}
                      alt="No folder to show"
                      className="no-folder-icon"
                    />
                    <p>
                      No {isSharedValue ? "shared" : "root"} folders to show
                    </p>
                  </div>
                )}
              </ul>
            </div>

            <div className="move-to-footer">
              <button className="cancel-btn" onClick={handleClose}>
                Cancel
              </button>
              <button
                className={`move-btn ${!isRadioChecked ? "disabled" : ""}`}
                onClick={handleConfirm}
                disabled={!isRadioChecked}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </ChakraProvider>
  );
}

export default SelectFolderModal;
